import type { ScheduleState } from '../types';

const selectActiveDateKey = (state: ScheduleState) => state.schedule.activeDateKey;

export { selectActiveDateKey };
